import { useSelector } from "react-redux";

type Selector = (arg0: any) => boolean;

export default function useAllTrue(...selectors: Selector[]): boolean {
  const allTrue = useSelector((state: any) =>
    selectors.every(selector => selector(state))
  );
  return allTrue;
}
